import React, { useContext } from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './Redux/Store/store';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'global.css';
import { ensureReady, After, getSerializedData } from '@jaredpalmer/after';
import routes from './routes';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppContextProvider } from './context/AppContext';
import './global.css';
import { AuthContextProvider } from './context/AuthContext';
import { ReactQueryDevtools } from 'react-query/devtools';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 24 * 3600 * 1000, // cache for 1 day
    },
  },
});
const helmetContext = {};
const preloadedState = getSerializedData('preloaded_state'); /// get data document shared
const store = configureStore(preloadedState); // change module hot


function renderApp() {
  ensureReady(routes).then(data => hydrate(
    <BrowserRouter>
      {/*<HelmetProvider context={helmetContext}>*/}
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AppContextProvider>
            <AuthContextProvider>
              <After data={data} routes={routes} store={store} />
              {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
            </AuthContextProvider>
          </AppContextProvider>
        </QueryClientProvider>
      </Provider>
      {/*</HelmetProvider>*/}
    </BrowserRouter>,
    document.getElementById('root'),
  ));
}

renderApp();

if (module.hot) {
  module.hot.accept('./routes', renderApp);
}
